import React from 'react'

const Cards = ({ title, imgSrc, link, tipo, descripcion }) => {
    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Ver proyecto ${title}${tipo ? ` (${tipo})` : ''}`}
            className="port-card"
        >
            <div className="port-card-img">
                <img src={imgSrc} alt={descripcion || title} loading="lazy" />
            </div>
            {tipo && <span className="port-card-tag">{tipo}</span>}
            <div className="port-card-overlay">
                <h3 className="port-card-title">{title}</h3>
                {descripcion && <p className="port-card-desc">{descripcion}</p>}
            </div>
        </a>
    );
}

export default Cards
